class DropdownManager {
  constructor() {
    this.timeouts = new Map();
    this.DELAY = 150;
    this.ANIMATION_DURATION = 150; // Match this to your CSS transition duration
    this.activeDropdownId = null;
    this.bodyClickHandler = this.handleBodyClick.bind(this);

    this.init();
  }

  init() {
    const navItems = document.querySelectorAll("#handsoff-nav > li");
    navItems.forEach((item) => this.setupNavItem(item));

    // Add body click handler to close dropdowns when clicking outside
    document.body.addEventListener("click", this.bodyClickHandler);
  }

  setupNavItem(navItem) {
    const dropdownId = navItem.getAttribute("data-content");

    if (dropdownId) {
      navItem.addEventListener("click", (event) => {
        // Prevent default link behavior for items with dropdowns
        event.preventDefault();
        event.stopPropagation(); // Prevent the body click from immediately closing the dropdown

        if (this.activeDropdownId === dropdownId) {
          // If clicking the same nav item, close the dropdown
          this.closeDropdown(dropdownId);
          this.activeDropdownId = null;
        } else {
          // Otherwise, open the requested dropdown
          this.resetActiveStates();
          navItem.classList.add("active");
          this.showDropdown(dropdownId);
          this.activeDropdownId = dropdownId;
        }
      });
    }
  }

  showDropdown(dropdownId) {
    // Hide any currently visible dropdown
    document
      .querySelectorAll("#handsoff-nav-dropdown > li")
      .forEach((dropdown) => dropdown.classList.add("hidden"));

    const dropdown = document.getElementById(dropdownId);
    if (dropdown) {
      dropdown.classList.remove("hidden");

      // Add the dropdown-open class if it's not already there
      if (!document.body.classList.contains("dropdown-open")) {
        document.body.classList.add("dropdown-open");
      }

      // Ensure dropdown-animate is applied (for animation)
      setTimeout(() => document.body.classList.add("dropdown-animate"), 15);
    }
  }

  closeDropdown(dropdownId) {
    // First remove the animate class to start the fade out
    document.body.classList.remove("dropdown-animate");

    // Wait for animation to complete before hiding dropdown
    this.setDelayedTimeout(
      "hide",
      () => {
        document.getElementById(dropdownId)?.classList.add("hidden");
        // Remove dropdown-open class after hiding the dropdown
        document.body.classList.remove("dropdown-open");
      },
      this.ANIMATION_DURATION
    );
  }

  closeAllDropdowns() {
    const openDropdown = document.querySelector(
      "#handsoff-nav-dropdown > li:not(.hidden)"
    );

    if (openDropdown) {
      // Just hide the dropdown without animation
      // This is used when switching between dropdowns
      openDropdown.classList.add("hidden");
    }
  }

  handleBodyClick(event) {
    // Check if the click was outside the navigation and dropdown areas
    const navArea = document.getElementById("handsoff-nav");
    const dropdownArea = document.getElementById("handsoff-nav-dropdown");

    // If click is outside both nav and dropdown areas, close any open dropdown
    if (
      this.activeDropdownId &&
      !navArea.contains(event.target) &&
      !dropdownArea.contains(event.target)
    ) {
      this.resetActiveStates();
      this.closeDropdown(this.activeDropdownId);
      this.activeDropdownId = null;
    }
  }

  setDelayedTimeout(key, callback, delay = this.DELAY) {
    this.clearTimeout(key);
    this.timeouts.set(key, setTimeout(callback, delay));
  }

  clearTimeout(key) {
    if (this.timeouts.has(key)) {
      clearTimeout(this.timeouts.get(key));
      this.timeouts.delete(key);
    }
  }

  clearTimeouts() {
    this.timeouts.forEach((timeout) => clearTimeout(timeout));
    this.timeouts.clear();
  }

  resetActiveStates() {
    document
      .querySelectorAll("#handsoff-nav > li[data-content]")
      .forEach((item) => item.classList.remove("active"));
  }
}

const dropdownManager = new DropdownManager();
